import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ActionsContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const ActionButton = styled.button`
  color: white;
  border: none;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }

  &.email-button {
    background-color: #28a745;

    &:hover {
      background-color: #218838;
    }
  }

  &.ignore-button {
    background-color: #dc3545;

    &:hover {
      background-color: #c82333;
    }
  }
`;

const TagSpan = styled.span`
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 2px 5px;
  margin: 2px;
  display: inline-block;
  background-color: #e9ecef;
  color: #495057;
  font-size: 12px;
`;

export const ActionsCell = ({ row, className, onLinkEmail, onIgnore }) => {
  return (
    <td className={className}>
      <ActionsContainer>
        <ActionButton
          className="email-button"
          onClick={() => onLinkEmail(row)}
          title="Link email to this folder"
        >
          <i className="fas fa-envelope"></i>
          Email
        </ActionButton>
        {row.MaxDescendantWOMemfis
          ? <TagSpan>{row.MaxDescendantWOMemfis}</TagSpan>
          : <ActionButton
              className="ignore-button"
              onClick={() => onIgnore(row)}
              title="Ignore this directory"
            >
              <i className="fas fa-eye-slash"></i>
              Ignore
            </ActionButton>
        }
      </ActionsContainer>
    </td>
  );
};

ActionsCell.propTypes = {
  row: PropTypes.object.isRequired,
  className: PropTypes.string,
  onLinkEmail: PropTypes.func.isRequired,
  onIgnore: PropTypes.func.isRequired
};